var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "17px",
    viewBox: "0 0 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uDBC0\uDF55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "occupational-health",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-1148, -322)",
    fill: "#CCF2FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-buttons",
    transform: "translate(1130, 300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(10, 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uDBC0\\uDF55",
    transform: "translate(8.6177, 12.1752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08822632,16.3293457 C2.0837911,16.3293457 1.31797791,16.0697683 0.790786743,15.5506134 C0.263595581,15.0314585 0,14.2712402 0,13.2699585 L0,3.05938721 C0,2.0598348 0.253550212,1.30004883 0.760650635,0.780029297 C1.26775106,0.260009766 1.97362264,0 2.87826538,0 L19.6763611,0 C20.6807963,0 21.4466095,0.260009766 21.9738007,0.780029297 C22.5009918,1.30004883 22.7645874,2.0598348 22.7645874,3.05938721 L22.7645874,13.2699585 C22.7645874,14.2712402 22.5110372,15.0314585 22.0039368,15.5506134 C21.4968363,16.0697683 20.7909648,16.3293457 19.886322,16.3293457 L3.08822632,16.3293457 Z M3.11309814,14.5019531 L19.6514893,14.5019531 C20.0615438,14.5019531 20.378774,14.392573 20.6031799,14.1738129 C20.8275859,13.9550527 20.9397888,13.6334737 20.9397888,13.2090759 L20.9397888,3.12286377 C20.9397888,2.69836426 20.8275859,2.37510681 20.6031799,2.15309143 C20.378774,1.93107605 20.0615438,1.82006836 19.6514893,1.82006836 L3.11309814,1.82006836 C2.70304362,1.82006836 2.3862203,1.93107605 2.16262817,2.15309143 C1.93903605,2.37510681 1.82723999,2.69510905 1.82723999,3.11309814 L1.82723999,13.2017517 C1.82723999,13.6310323 1.93903605,13.9550527 2.16262817,14.1738129 C2.3862203,14.392573 2.70304362,14.5019531 3.11309814,14.5019531 Z M11.3786316,10.730896 C11.0503642,10.730896 10.7387288,10.6693268 10.4437256,10.5461884 C10.1487223,10.4230499 9.85743205,10.2316284 9.56985474,9.97192383 L0.962219238,2.21862793 L2.12753296,1.04827881 L10.5758667,8.65509033 C10.8306885,8.89038086 11.0982768,9.00802612 11.3786316,9.00802612 C11.6589864,9.00802612 11.9290161,8.89038086 12.1887207,8.65509033 L20.6324768,1.04827881 L21.8048096,2.21862793 L13.1874084,9.97192383 C12.8999329,10.2316284 12.608668,10.4230499 12.3136139,10.5461884 C12.0185598,10.6693268 11.706899,10.730896 11.3786316,10.730896 Z M2.2869873,14.9394226 L1.11923218,13.7644958 L7.63870239,7.25234985 L8.81652832,8.41003418 L2.2869873,14.9394226 Z M20.4847717,14.9467468 L13.9407349,8.41003418 L15.128479,7.25234985 L21.6549683,13.7716675 L20.4847717,14.9467468 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b2961e2fb00f0ceca14142f675cb8c0c.svg";
export { ForwardRef as ReactComponent };